import React, { Component } from 'react'
import './login.css';
import Login from './login'


export default class Loginroot extends Component {
  render() {
    return (
        <Login />
    )
  }
}


// WEBPACK FOOTER //
// ./src/auth/login/root.js